export enum EIssueStatus {
  ToDo = 'К выполнению',
  InProgress = 'В работе',
  InReview = 'На ревью',
  InVerification = 'На проверке',
  Done = 'Готово',
}

export enum IssueSelectType {
  users = 'users',
  managers = 'managers',
  customers = 'customers',
  sprints = 'sprints',
  epics = 'epics',
  types = 'types',
}

export enum ERole {
  project_employee = 'project_employee',
  project_manager = 'project_manager',
  project_owner = 'project_owner',
  employee = 'employee',
  manager = 'manager',
  owner = 'owner',
}
